<template>
  <b-form-group :label="label" :label-for="inputId" :description="description">
    <b-form-select
      :id="inputId"
      v-model="internalValue"
      :options="leadsExtractedOptions"
      :required="required"
      :state="isValid"
      @change="handleChange"
      @blur="handleBlur"
    >
      <option disabled value="">Selecione...</option>
    </b-form-select>
    <b-form-invalid-feedback :id="`${inputId}-feedback`">
      {{ invalidFeedback }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: 'LeadsExtractedSelect',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Leads extraídos?',
    },
    inputId: {
      type: String,
      default: 'leads-extracted-select-input',
    },
    description: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: true,
    },
    invalidFeedback: {
      type: String,
      default: 'Por favor, selecione uma opção.',
    },
    validationFunc: {
      type: Function,
      default: null,
    },
    state: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      internalValue: this.value,
      isValid: this.state,
      leadsExtractedOptions: [
        { value: null, text: 'Ambos - Extraídos e não extraídos' },
        { value: true, text: 'Sim' },
        { value: false, text: 'Não' },
      ],
    };
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
      this.validate();
    },
    state(newVal) {
      this.isValid = newVal;
    },
  },
  mounted() {
    if (this.internalValue) {
      this.validate();
    }
  },
  methods: {
    handleChange() {
      this.$emit('input', this.internalValue);
      this.validate();
    },
    handleBlur() {
      this.validate();
    },
    validate() {
      if (!this.validationFunc) {
        this.isValid = this.required ? !!this.internalValue : null;
      } else {
        this.isValid = this.validationFunc(this.internalValue);
      }
      this.$emit('validation-updated', this.isValid);
    },
  },
};
</script>
